<!-- Fixed Header -->
<nav class="fixed w-full z-50 bg-white/80 backdrop-blur-md border-b border-gray-200 shadow-sm print:hidden">
  <div class="px-4 sm:px-6 lg:px-8">
    <div class="flex justify-between items-center h-14 lg:h-16">
      <!-- Dashboard Button (Left) -->
      <a
        routerLink="/dashboard"
        class="flex items-center gap-2 px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl font-bold text-xs sm:text-sm transition-all cursor-pointer"
      >
        <lucide-icon [img]="icons.LayoutDashboard" class="w-4 h-4"></lucide-icon>
        <span class="hidden sm:inline">Dashboard</span>
      </a>

      <!-- Center Navigation Tabs (Desktop only) -->
      <div class="hidden lg:flex bg-gray-100 p-1 rounded-xl max-w-2xl">
        <a
          routerLink="presenter"
          routerLinkActive="bg-white shadow-sm text-gray-900"
          [routerLinkActiveOptions]="{ exact: true }"
          class="px-3 py-2 rounded-lg font-bold text-sm transition-all flex items-center justify-center gap-1.5 cursor-pointer whitespace-nowrap text-gray-500"
        >
          <lucide-icon [img]="icons.Presentation" class="w-4 h-4"></lucide-icon>
          <span>Presenter View</span>
        </a>
        <a
          routerLink="admin-plan"
          routerLinkActive="bg-white shadow-sm text-gray-900"
          class="px-3 py-2 rounded-lg font-bold text-sm transition-all flex items-center justify-center gap-1.5 cursor-pointer whitespace-nowrap text-gray-500"
        >
          <lucide-icon [img]="icons.FileText" class="w-4 h-4"></lucide-icon>
          <span>Administrative Plan</span>
        </a>
        <a
          routerLink="assignments"
          routerLinkActive="bg-white shadow-sm text-gray-900"
          class="px-3 py-2 rounded-lg font-bold text-sm transition-all flex items-center justify-center gap-1.5 cursor-pointer whitespace-nowrap text-gray-500"
        >
          <lucide-icon [img]="icons.ClipboardList" class="w-4 h-4"></lucide-icon>
          <span>Assignments</span>
        </a>
        <a
          routerLink="grading"
          routerLinkActive="bg-white shadow-sm text-gray-900"
          class="px-3 py-2 rounded-lg font-bold text-sm transition-all flex items-center justify-center gap-1.5 cursor-pointer whitespace-nowrap text-gray-500"
        >
          <lucide-icon [img]="icons.GraduationCap" class="w-4 h-4"></lucide-icon>
          <span>Grading</span>
        </a>
      </div>

      <!-- Right Actions -->
      <div class="flex items-center gap-2">
        <!-- Export Button -->
        <button
          (click)="openExportModal()"
          class="flex items-center gap-2 px-3 py-2 bg-gray-900 hover:bg-gray-800 text-white rounded-xl font-bold text-xs sm:text-sm transition-all shadow-md cursor-pointer"
        >
          <lucide-icon [img]="icons.Share2" class="w-4 h-4"></lucide-icon>
          <span>Export</span>
        </button>

        <!-- Feedback Button -->
        <button
          (click)="openFeedbackModal()"
          class="flex items-center gap-2 px-3 py-2 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white rounded-xl font-bold text-xs sm:text-sm transition-all shadow-md cursor-pointer"
        >
          <lucide-icon [img]="icons.MessageSquareHeart" class="w-4 h-4"></lucide-icon>
          <span>Feedback</span>
        </button>
      </div>
    </div>
  </div>
</nav>

<!-- Bottom Navigation (Mobile/Tablet only) -->
<nav class="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg lg:hidden print:hidden">
  <div class="flex justify-around items-center h-16 px-2">
    <a
      routerLink="presenter"
      routerLinkActive #presenterActive="routerLinkActive"
      [routerLinkActiveOptions]="{ exact: true }"
      class="flex flex-col items-center justify-center gap-1 py-2 px-3 rounded-lg transition-all cursor-pointer"
      [class.text-brand]="presenterActive.isActive"
      [class.text-gray-500]="!presenterActive.isActive"
    >
      <lucide-icon [img]="icons.Presentation" class="w-5 h-5"></lucide-icon>
      <span class="text-[10px] font-semibold">Present</span>
    </a>
    <a
      routerLink="admin-plan"
      routerLinkActive #adminActive="routerLinkActive"
      class="flex flex-col items-center justify-center gap-1 py-2 px-3 rounded-lg transition-all cursor-pointer"
      [class.text-brand]="adminActive.isActive"
      [class.text-gray-500]="!adminActive.isActive"
    >
      <lucide-icon [img]="icons.FileText" class="w-5 h-5"></lucide-icon>
      <span class="text-[10px] font-semibold">Admin</span>
    </a>
    <a
      routerLink="assignments"
      routerLinkActive #assignActive="routerLinkActive"
      class="flex flex-col items-center justify-center gap-1 py-2 px-3 rounded-lg transition-all cursor-pointer"
      [class.text-brand]="assignActive.isActive"
      [class.text-gray-500]="!assignActive.isActive"
    >
      <lucide-icon [img]="icons.ClipboardList" class="w-5 h-5"></lucide-icon>
      <span class="text-[10px] font-semibold">Assign</span>
    </a>
    <a
      routerLink="grading"
      routerLinkActive #gradeActive="routerLinkActive"
      class="flex flex-col items-center justify-center gap-1 py-2 px-3 rounded-lg transition-all cursor-pointer"
      [class.text-brand]="gradeActive.isActive"
      [class.text-gray-500]="!gradeActive.isActive"
    >
      <lucide-icon [img]="icons.GraduationCap" class="w-5 h-5"></lucide-icon>
      <span class="text-[10px] font-semibold">Grade</span>
    </a>
  </div>
</nav>

@if (loading$ | async) {
  <div class="flex flex-col items-center justify-center min-h-screen text-center space-y-4 pt-16">
    <div
      class="w-12 h-12 border-4 border-gray-200 rounded-full animate-spin"
      [style.borderTopColor]="themeColor"
    ></div>
    <p class="text-gray-500 font-medium">Designing slides & script...</p>
  </div>
} @else {
  <!-- Export Modal (always available) -->
  <app-export-modal [isOpen]="isExportModalOpen()" (closed)="closeExportModal()"></app-export-modal>

  <!-- Feedback Modal -->
  <app-feedback-modal 
    [isOpen]="isFeedbackModalOpen()" 
    [feedbackType]="'share_feedback'"
    [lessonPlanId]="lessonPlanId$ | async"
    (closed)="closeFeedbackModal()"
  ></app-feedback-modal>

  <!-- Print Area (Hidden on screen) -->
  @if (inputData$ | async; as inputData) {
    <div class="hidden print:block p-8">
      <h1 class="text-3xl font-bold mb-4">{{ inputData.topic }} Lesson Plan</h1>
      @if (planStructure$ | async; as plan) {
        <div class="mb-8">
          <h2 class="text-xl font-bold border-b pb-2 mb-4">1. Administrative Plan</h2>
          @for (block of plan; track block.id) {
            <div class="mb-4">
              <div class="font-bold">{{ block.phase }} ({{ block.time }}m)</div>
              <div>{{ block.activity }}</div>
              <div class="text-gray-600 italic">{{ block.description }}</div>
            </div>
          }
        </div>
      }
      @if (slides$ | async; as slides) {
        <div>
          <h2 class="text-xl font-bold border-b pb-2 mb-4">2. Script & Slides</h2>
          @for (slide of slides; track $index; let i = $index) {
            <div class="mb-6 p-4 border rounded">
              <h3 class="font-bold text-lg mb-2">Slide {{ i + 1 }}: {{ getSlideTitle(slide) }}</h3>
              <div class="text-sm text-gray-500 mb-2">Type: {{ slide.type }}</div>
              @if (slide.teacherScript) {
                <div class="whitespace-pre-wrap">{{ slide.teacherScript }}</div>
              }
            </div>
          }
        </div>
      }
    </div>
  }

  <!-- Content projection for router-outlet from parent -->
  <ng-content></ng-content>
}
